<template>
  <a
    class="rodape-recomendado-item"
    :class="{ 'rodape-recomendado-item--inter': isInterTheme }"
    :href="href"
    target="_blank"
    rel="noreferrer"
    :data-ua="dataUa"
  >
    <component :is="icon" class="rodape-recomendado-item__icone" aria-hidden="true" />
    <span class="rodape-recomendado-item__conteudo">
      <span class="rodape-recomendado-item__titulo">{{ titulo }}</span>
      <span class="rodape-recomendado-item__descricao">{{ descricao }}</span>
    </span>
  </a>
</template>

<script setup lang="ts">
import type { Component } from 'vue';
import theme from '@/services/ThemeService';

defineProps<{
  icon: Component;
  titulo: string;
  descricao: string;
  href: string;
  dataUa: string;
}>();

const isInterTheme = theme.isInterTheme();
</script>

<style scoped lang="scss">
@use "@/assets/styles/functions.scss" as *;
@use "@/assets/styles/vars" as *;

.rodape-recomendado-item {
  display: flex;
  align-items: flex-start;
  gap: $space-xxs;
  padding: $space-xxs $space-xs;
  background: var(--neutral-FF, #fff);
  border: 1px solid var(--acerto-colors-green-700, #1f7a40);
  border-radius: $border-radius;
  text-decoration: none;

  &.rodape-recomendado-item--inter {
    border-color: var(--primary-color-normal);

    .rodape-recomendado-item__icone {
      color: var(--primary-color-normal);
    }
  }
}

.rodape-recomendado-item__icone {
  flex-shrink: 0;
  margin-top: 2px;
  width: 22px;
  height: 22px;
  color: var(--acerto-colors-green-700, #1f7a40);
}

.rodape-recomendado-item__conteudo {
  display: flex;
  flex-direction: column;
  gap: px2rem(3px);
}

.rodape-recomendado-item__titulo {
  font-size: px2rem(14px);
  font-weight: 700;
  color: var(--neutral-00, #131416);
}

.rodape-recomendado-item__descricao {
  font-size: px2rem(12.5px);
  line-height: 1.5;
  color: var(--neutral-77, #777);
}
</style>
